import i18n from "i18next";

import translationEs from "./locales/es/translation.json";

i18n.init({
  debug: false,
  lng: "es",
  fallbackLng: "es",

  keySeparator: false,
  interpolation: {
    escapeValue: false,
  },

  resources: {
    es: {
      translations: translationEs,
    },
  },
  ns: ["translations"],
  defaultNS: "translations",
});

export default i18n;
